import { render } from "./AnnouncementsView.vue?vue&type=template&id=058c0100"
import script from "./AnnouncementsView.vue?vue&type=script&lang=js"
export * from "./AnnouncementsView.vue?vue&type=script&lang=js"

import "./AnnouncementsView.vue?vue&type=style&index=0&id=058c0100&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__